export default function HowItWorks() {
  const steps = [
    {
      number: 1,
      title: 'Download & Install',
      description: 'Get our VPN app for your device and install it in seconds with our simple setup wizard'
    },
    {
      number: 2,
      title: 'Connect to Server',
      description: 'Choose from our global server network and connect with a single click for instant protection'
    },
    {
      number: 3,
      title: 'Browse Securely',
      description: 'Enjoy complete privacy and security while browsing, streaming, and accessing content worldwide'
    }
  ];

  return (
    <section id="how-it-works" className="py-24 bg-gradient-to-b from-white to-blue-50/30">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-20">
          <h2 className="text-5xl font-bold text-gray-900 mb-4">Get Protected in 3 Steps</h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Start securing your online presence in minutes with our simple process
          </p>
        </div>

        <div className="relative">
          <div className="absolute top-1/2 left-0 right-0 h-1 bg-blue-600 transform -translate-y-1/2 hidden lg:block"></div>
          
          <div className="absolute top-1/2 left-0 right-0 transform -translate-y-1/2 hidden lg:block">
            <div className="flex justify-between max-w-5xl mx-auto px-12">
              <div className="w-3 h-3 rounded-full bg-blue-600 animate-pulse"></div>
              <div className="w-3 h-3 rounded-full bg-blue-600 animate-pulse animation-delay-300"></div>
              <div className="w-3 h-3 rounded-full bg-blue-600 animate-pulse animation-delay-600"></div>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 lg:gap-24 relative z-10">
            {steps.map((step, index) => (
              <div key={index} className="text-center">
                <div className="w-32 h-32 mx-auto mb-8 rounded-full bg-white border-4 border-blue-600 flex items-center justify-center shadow-lg hover:scale-110 transition-transform duration-300">
                  <span className="text-5xl font-bold text-blue-600">{step.number}</span>
                </div>
                <h3 className="text-2xl font-semibold text-gray-900 mb-4">{step.title}</h3>
                <p className="text-gray-600 leading-relaxed max-w-xs mx-auto">{step.description}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-16 text-center">
          <button
            onClick={() => {
              const element = document.getElementById('contact');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            className="px-10 py-4 bg-blue-600 text-white text-base font-semibold rounded-full hover:bg-blue-700 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
          >
            Get Started Now
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}
